// Dependencies
import styled from 'styled-components';

const NewsletterFormStyles = styled.section`
  position: relative;
  width: 100%;
  margin: 0 auto;
  padding: 2rem 1.5rem;
  background-color: ${(props) =>
    props?.blog ? 'transparent' : 'var(--color-sand)'};
  text-align: ${(props) => (props?.page || props?.blog ? 'center' : 'left')};

  .bg {
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: bottom;
    object-position: center;
  }

  .inner.blog {
    padding: 1rem;
    background: rgba(255, 255, 255, 0.95);
  }

  .heading {
    margin-bottom: ${(props) => (props?.page || props?.blog ? '1rem' : 0)};
    line-height: 1;
  }

  p {
    max-width: ${(props) => (props?.page ? '50%' : 'none')};
    margin: 0 auto 1rem;
    font-size: 0.938rem;
  }

  form {
    input,
    button {
      max-width: 25rem;
    }

    input {
      display: block;
      width: 100%;
      margin: 0 auto ${(props) => (props?.blog ? '1rem' : 0)} auto;
      text-align: center;
    }

    .form-success p {
      margin: 0 0 1rem;

      &:last-child {
        margin: 0;
      }
    }

    .form-error {
      p {
        color: var(--color-error);
      }
    }

    .btn {
      margin: 1.8rem auto 0;
    }
  }

  @media (min-width: 768px) {
    max-width: ${(props) => (props?.page ? '37.5rem' : 'none')};

    .inner.blog {
      padding: 2rem;
    }

    .heading {
      ${(props) => !props?.blog && 'font-size: 1.188rem;'}
    }

    p {
      margin-bottom: ${(props) => (props?.page || props?.blog ? '2rem' : 0)};
      max-width: none;
      font-size: 1.125rem;
    }

    form {
      input {
        margin: 0 auto ${(props) => (props?.blog ? '2rem' : 0)} auto;
      }
    }

    .btn {
      max-width: ${(props) => (props?.page ? '17.5rem' : 'none')};
      margin-top: ${(props) => (props?.page ? '2rem' : 0)};
    }
  }

  @media (min-width: 1200px) {
    padding: 2.5rem 2rem;

    form {
      input {
        text-align: ${(props) => (props?.page ? 'center' : 'left')};
      }
    }
  }
`;

export default NewsletterFormStyles;
